import { Line } from "react-chartjs-2";
import { useState, useEffect } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS, CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  BarController,
  BarElement
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  ChartDataLabels,
  BarController,
  BarElement
)

ChartJS.defaults.color = "#000000";

function ChartBarLine(props) {
  const { resultadoState } = props;
    // Extraindo os valores necessários
    const dataA = resultadoState.grapData[0];
    const dataB = resultadoState.grapData[1];
    const aName = resultadoState.nameA;
    const bName = resultadoState.nameB;
    const title = resultadoState.grapTitle;
    const yTitle = resultadoState.yName;
    const xTitle = 'Anos';
    const stepSize = 1000; // Supondo um step size fixo

    // Passando os valores extraídos para o componente
  
  const [newLineA, setNewLineA] = useState([]);
  const [newLineB, setNewLineB] = useState([]);
  const pointRadius = 8;
  const borderWidth = 5;
  const yTitleDisplay = true;
  const xTitleDisplay = true;
  const yTitleSize = 28;
  const xTitleSize = 28;
  const yLabelSize = 28;
  const xLabelSize = 28;
  const mainTitleSize = 38;
  const legendSize = 28;
  const xStepSize = 1;
  const yStepSize = stepSize;

  useEffect(() => {
    // Verificar se dataA e dataB existem e se possuem o segundo elemento (índice 1)
    if (dataA && dataB) { 
      // Filtrar os dados com base no período
      const filteredA = dataA.filter(data => data.ano >= 2000 && data.ano <= 2044);
      const filteredB = dataB.filter(data => data.ano >= 2000 && data.ano <= 2044);
      // Atualizar os estados com os dados filtrados
      setNewLineA(filteredA);
      setNewLineB(filteredB);
    }
  }, [dataA, dataB]); 

  if (dataA?.length === 0 || dataA === null || dataB?.length === 0 || dataB === null) {
    return (
      <div>
      </div>
    )
  } else {
    dataA.sort((a, b) => parseFloat(a.ano) - parseFloat(b.ano));
    dataB.sort((a, b) => parseFloat(a.ano) - parseFloat(b.ano));

    var data = {
      labels: newLineA.map((val) => (val.ano).toString()),
      datasets: [
        {
          label: bName,
          data: newLineB.map((val) => parseFloat(val.quantidade)),
          backgroundColor: '#dddf00a0',
          borderColor: '#dddf00',
          borderWidth: borderWidth,
          borderDash: [10, 5],
          // pointStyle: 'circle',
          pointRadius: pointRadius,
          tension: 0.3
        },
        {
          label: aName,
          data: newLineA?.map((val) => parseFloat(val.quantidade)),
          backgroundColor: '#df0000a0',
          borderColor: '#df0000',
          borderDash: [10, 5],
          borderWidth: borderWidth,
          pointRadius: pointRadius,
          tension: 0.3
        }
      ]
    }

    var options = {
      responsive: true,
      maintainAspectRatio: false,
      locale: 'pt-br',
      scales: {
        y: {
          title: {
            display: yTitleDisplay,
            text: yTitle,
            color: '#1E3050',
            font: {
              size: yTitleSize
            }
          },
          beginAtZero: true,
          ticks: {
            // autoSkip: false,
            color: '#1E3050',
            stepSize: yStepSize,
            font: {
              size: yLabelSize
            }
          },
          grid: {
            color: '#52525200',
          }
        },
        x: {
          title: {
            display: xTitleDisplay,
            text: xTitle,
            color: '#1E3050',
            font: {
              size: xTitleSize
            }
          },
          grid: {
            color: '#52525200',
          },
          ticks: {
            autoSkip: false,
            color: '#1E3050',
            stepSize: xStepSize,
            font: {
              size: xLabelSize
            }
          },
        }
      },
      plugins: {
        datalabels: {
          display: false
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            padding: 10,
            color: '#1E3050',
            font: {
              size: legendSize
            }
          },
        },
        title: {
          display: true,
          text: title,
          color: '#1E3050',
          font: {
            size: mainTitleSize
          }
        },
        subtitle: {
          display: true,
          text: 'Aterro Sanitário - Central de Resíduos do Recreio, Minas do Leão/RS'
        }
      },
    }
  
    return (
      <div className={'w-[98vw] h-[90vh]'}>
        <Line data={data} options={options} />
        {/* <button onClick={() => changeFill(fillChart)}>Área</button> */}
      </div>
    )
  }
}

export default ChartBarLine;